import { Routes } from '@angular/router';
import { ListCountries } from './components/list-countries/list-countries';
import { ListZones } from './components/list-zones/list-zones';
import { ListPackages } from './components/list-packages/list-packages';
import { ListAreas } from './components/list-areas/list-areas';
import { ListUsageRates } from './components/list-usage-rates/list-usage-rates';
import { ShowUsageRate } from './components/show-usage-rate/show-usage-rate';
import { NotFound } from './components/not-found/not-found';
import { ShowPackage } from './components/show-package/show-package';
import { ListServices } from './components/list-services/list-services';

export const routes: Routes = [
    {
        path: '',
        redirectTo: '/usageRates',
        pathMatch: 'full'
    },
    {
        path: 'countries',
        component: ListCountries
    },
    {
        path: 'services',
        component: ListServices
    },
    {
        path: 'zones',
        component: ListZones
    },
    {
        path: 'packages',
        component: ListPackages
    },
    {
        path: 'packages/:uuid',
        component: ShowPackage
    },
    {
        path: 'areas',
        component: ListAreas
    },
    {
        path: 'usageRates',
        component: ListUsageRates
    },
    {
        path: 'usageRates/:uuid',
        component: ShowUsageRate
    },
    {
        path: '**',
        component: NotFound
    }
];
